export const VENDING_SHIFT_REPORT_SECTION_GAP_ROWS = 22;

export const getVendingShiftReportImageLineCount = (
  salesLineCount: number,
  inventoryLineCount: number,
): number => {
  if (salesLineCount <= 0 && inventoryLineCount <= 0) {
    return 0;
  }

  if (salesLineCount <= 0 || inventoryLineCount <= 0) {
    return salesLineCount + inventoryLineCount;
  }

  return salesLineCount + VENDING_SHIFT_REPORT_SECTION_GAP_ROWS + inventoryLineCount;
};

export const getVendingShiftReportInventoryHoverIndex = (
  salesLineCount: number,
  inventoryIndex: number,
): number => salesLineCount + VENDING_SHIFT_REPORT_SECTION_GAP_ROWS + inventoryIndex + 1;
